<template>
  <n-loading-bar-provider>
    <n-message-provider placement="bottom-left" :duration="2500">
      <!-- <n-notification-provider> -->
      <n-dialog-provider>
        <Header />
        <Viewer />
        <!-- <Footer /> -->
      </n-dialog-provider>
      <!-- </n-notification-provider> -->
    </n-message-provider>
  </n-loading-bar-provider>
</template>

<script>
import Header from "./src/components/landing/header.vue";
import NavBar from "./src/components/navbar.vue";
import Viewer from "./src/components/viewer.vue";
import Footer from "./src/components/landing/footer.vue";
import { mapActions } from 'pinia';
import useConfiguration from './src/store/configuration';
export default {
  components: {
    Header,
    NavBar,
    Viewer,
    Footer,
  },
  methods: {
    ...mapActions(useConfiguration, ['getConfiguration'])
  },
  async mounted() {
    await this.getConfiguration()
  }
};
</script>

<style></style>
